/**
 * @file menu.class.js
 * @description Defines the Menu class.
 */

class Menu {
  constructor(debug = false) {
    this.elMenuDesktop = Helper.getElement('.menu.menu--desktop');
    this.elMenuMobile = Helper.getElement('.menu.menu--mobile');
    this.elMenuToggleMobile = Helper.getElements('.mobile__toggle');

    if (this.elMenuDesktop) {
      this.elMenuDesktopToggles = this.elMenuDesktop.querySelectorAll('li.parent[data-depth="0"]');
    }

    if (this.elMenuMobile) {
      this.elMenuMobileToggles = this.elMenuMobile.querySelectorAll('.parent');
    }

    this.state = {
      mobile: {
        isOpen: false
      }
    }
    this.init();
    this.debug();
  }

  init() {
    if (this.elMenuDesktop) {
      this.initIcons(this.elMenuDesktop, this.elMenuDesktopToggles);
      this.initActive(this.elMenuDesktop);
    }

    if (this.elMenuMobile) {
      this.initIcons(this.elMenuMobile, this.elMenuMobileToggles);
      this.initActive(this.elMenuMobile);
    }

    if (this.elMenuDesktop || this.elMenuMobile) {
      this.bindEvents();
    }
  }

  /**
   * @description Inserts dropdown icons into the specified menu. If the specified
   * menu is menu--desktop the icons are only inserted into the first level. If the
   * specified menu is menu--mobile the icons are used as dropdown toggles.
   * @param {Node} elMenu The menu to pass in.
   * @param {NodeList} elToggles The toggles to add the icon to.
   */
  initIcons(elMenu, elToggles) {
    let icon = elMenu.dataset.dropdownIcon !== '' ? elMenu.dataset.dropdownIcon : false;
    let isDesktop = elMenu.classList.contains('menu--desktop') ? true : false;

    if (icon) {
      elToggles.forEach( elToggle => {
        let elIcon = document.createElement('i');
        elIcon.className += 'icon ' + icon;
        
        if (isDesktop) {
          let anchor = elToggle.querySelector('a');
          anchor.appendChild(elIcon);
        } else {
          elToggle.appendChild(elIcon);
        }
        
      });
    }
  }

  /**
   * @description Adds an active class to each parent list item starting from the current active list item.
   * @param {node} elMenu The menu to add active classes to.
   */
  initActive(elMenu) {
    let elActiveItem = elMenu.querySelector('.active');
    let elParentItem = elActiveItem !== null ? elActiveItem.parentNode.closest('li.parent') : null;
    
    while (elParentItem !== null) {
      elParentItem.classList.add('active');
      elParentItem = elParentItem.parentNode.closest('li.parent');
    }
  }

  bindEvents() {
    document.addEventListener('click', event => { this.handleDocument(event); });
    document.addEventListener('touch', event => { this.handleDocument(event); });

    this.elMenuDesktopToggles.forEach( el => {
      el.addEventListener('mouseenter', event => { this.preventOverflow(event); });

      let elDropdowns = el.querySelectorAll('ul.dropdown');
      elDropdowns.forEach( elDropdown => {
        elDropdown.addEventListener('mouseenter', event => { this.preventOverflow(event); });
      });
    });

    this.elMenuMobileToggles.forEach( el => {
      //let elIcon = el.querySelector('i'); // Not selecting the first node.
      let elIconList = el.querySelectorAll('img');
      let elIcon = elIconList[elIconList.length - 1];
      elIcon.addEventListener('click', event => { this.handleMobileDropdownToggle(event); });
      elIcon.addEventListener('touch', event => { this.handleMobileDropdownToggle(event); });
    });

    this.elMenuToggleMobile.forEach( el => {
      el.addEventListener('click', () => { this.handleMobileToggle(); });
      el.addEventListener('touch', () => { this.handleMobileToggle(); });
    });
  }

  /**
   * @description Handles events outside of the mobile menu.
   * @param {event} event The event passed to this function. 
   */
  handleDocument(event) {
    let target = event.target;
    let isMobileMenu = target.closest('.menu.menu--mobile');

    if (this.state.mobile.isOpen) {
      if (isMobileMenu === null) {
        this.handleMobileToggle();
      }
    }
  }

  /**
   * @description Handles mobile toggle events
   */
  handleMobileToggle() {
    Helper.toggleClass(this.elMenuMobile, 'active');
    this.setMobileOpenState();
  }

  /**
   * @description Handles mobile dropdown toggles
   * @param {event} event 
   */
  handleMobileDropdownToggle(event) {
    event.stopPropagation();
    let elIcon = event.target;
    let elParent = elIcon.closest('.parent');
    let elDropdown = elParent.querySelector('ul');

    Helper.toggleClass(elIcon, 'active');
    Helper.toggleClass(elDropdown, 'active');

    if (elDropdown.classList.contains('active')) {
      // Smoother transition, need to loop through each parent submenu and set the maxheight
      //elDropdown.style.maxHeight = elDropdown.scrollHeight + 'px'; 
      elDropdown.style.maxHeight = 10000 + 'px';

    } else {
      elDropdown.style.maxHeight = 0 + 'px';
    }

  }

  /**
   * @description Sets the state of isOpen for mobile.
   */
  setMobileOpenState() {
    if (this.elMenuMobile.classList.contains('active')) {
      let transitionDuration = Helper.getTransitionDuration(this.elMenuMobile, true);
      setTimeout(() => {
        this.state.mobile.isOpen = true;
      }, transitionDuration);
    } else {
      this.state.mobile.isOpen = false;
    }
  }

  /**
   * @description Prevents desktop dropdowns from overflowing past the screen.
   */
  preventOverflow(event) {
    let elDropdown = event.target.querySelector('ul.dropdown') !== null ?
                    event.target.querySelector('ul.dropdown') : null;

    if (elDropdown === null) return;
                
    let elChildDropdown = elDropdown.querySelector('ul.dropdown') !== null ? 
                          elDropdown.querySelector('ul.dropdown') : null;
    let dropdownRight = this.getPositionFromRight(elDropdown);
    let childDropdownRight = this.getPositionFromRight(elChildDropdown);

    if (dropdownRight < 0) {
      elDropdown.classList.add('display-left');
    }

    if (childDropdownRight < 0 && elChildDropdown !== null) {
      elChildDropdown.classList.add('display-left');
    }
  }

  /**
   * @description Returns a negative value if the passed element is overflowing.
   * @param {Node} elDropdown 
   */
  getPositionFromRight(elDropdown) {
    if (elDropdown === null) return;
    let windowWidth = window.innerWidth;
    let rect = elDropdown.getBoundingClientRect();
    let positionleft = rect.left;
    let width = elDropdown.clientWidth;
    return windowWidth - (positionleft + width);
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c Menu', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}